export const colors = {
    GREEN: '#18775f',
    LIGHT_GREEN: '#84c675',
    SUCCESS_GREEN: '#019811',
    LIME: '#34e500',
    BLUE: "#0000FF",
    LIGHT_ORANGE: '#fdd546',
    ORANGE: '#fbaa01',
    GRAY1: '#aaa',
    GRAY2: '#ccc',
    GRAY3: '#eee',
    GRAY4: '#6c7987',
    LIGHT_GRAY: 'rgb(99, 115, 129)',
    LIGHT_GRAY_HALF_TRANS: 'rgba(99, 115, 129,0.314)',
    RED1: 'red',
    WARM_RED: '#d10909',
    BLACK_LIGHT: '#151515',
    WHITE: '#fff',
    WHITE20: '#ffffff20',
    WHITE40: '#ffffff40',
    WHITE60: '#ffffff60',
    WHITE80: '#ffffff80',
    PINK: '#FF00BF',
    BLACK_WITH_HALF_TRANS: 'rgba(0,0,0,0.5)',
    BOX_AREA: 'rgba(248, 0, 0, 0.314)',
    CYAN: '#00bcd4',
    TEAL: '#009688',
    ORANGE_LIGHT: '#ff9800',
    COLLECTION: [
        "#000000",
        "#000080",
        "#00008B",
        "#0000CD",
        "#0000FF",
        "#006400",
        "#008000",
        "#008080",
        "#008B8B",
        "#00BFFF",
        "#00CED1",
        "#00FA9A",
        "#00FF00",
        "#00FF7F",
        "#00FFFF",
        "#00FFFF",
        "#191970",
        "#1E90FF",
        "#20B2AA",
        "#228B22",
        "#2E8B57",
        "#2F4F4F",
        "#32CD32",
        "#3CB371",
        "#40E0D0",
        "#4169E1",
        "#4682B4",
        "#483D8B",
        "#48D1CC",
        "#4B0082",
        "#556B2F",
        "#5F9EA0",
        "#6495ED",
        "#66CDAA",
        "#696969",
        "#6A5ACD",
        "#6B8E23",
        "#708090",
        "#778899",
        "#7B68EE",
        "#7CFC00",
        "#7FFF00",
        "#7FFFD4",
        "#800000",
        "#800080",
        "#808000",
        "#808080",
        "#87CEEB",
        "#87CEFA",
        "#8A2BE2",
        "#8B0000"
    ]
}